const configApp = require('../../app');

const isNative = !configApp || !configApp.isWebApp;

const ReactNative = {
  isProduction: false,
};
try {
  // eslint-disable-next-line no-undef
  ReactNative.isProduction = !__DEV__;
} catch (e) {
  // Not thing
}

if (process.env.NODE_ENV === 'production' || ReactNative.isProduction) {
  module.exports = require(`./configureStore.prod`);
} else {
  module.exports = require(`./configureStore.dev`);
}
// }
